import { Button, Text } from "../../../components";
import Localization from "../../../localization";
import { AuthLayout } from "../../../layouts";
import Images from "../../../assets/images";
import styled from "styled-components";
import { SVGs } from "../../../assets";
import { Flex } from "antd";
import React from "react";

const View = ({
  refs = {},
  onSignin = () => {},
  onPurchase = () => {},
  onLearnMore = () => {},
}) => {
  return (
    <Styled>
      <header>
        <SVGs.fullLogo color="currentColor" />
        <Button
          color="secondary"
          onClick={onSignin}
          className="d-none-mobile"
          title={Localization.general.login}
        />
        <Button
          color="tertiary"
          onClick={onSignin}
          className="d-none d-block-mobile"
          title={Localization.general.login}
        />
      </header>
      <Flex
        gap={"2.3rem"}
        align="center"
        className="content"
        justify="space-between"
      >
        <div>
          <Text
            level={2}
            weight={700}
            lineHeight="normal"
            children={Localization.authentication.title}
          />
          <Flex
            vertical
            gap={"1rem"}
            className="m-30-t"
            children={React.Children.toArray(
              Array.from({ length: 4 }).map((_, index) => (
                <div>
                  <Text
                    weight={700}
                    level={5}
                    children={
                      Localization.authentication[`info_${index}_title`]
                    }
                  />
                  <Text
                    type="secondary"
                    className="m-2-t"
                    children={Localization.authentication[`info_${index}_desc`]}
                  />
                </div>
              ))
            )}
          />
          <Flex className="m-40-t" gap={"1rem"}>
            <Button
              type="primary"
              title={Localization.general.purchase}
              onClick={onPurchase}
            />
            <Button
              title={Localization.general.read_more}
              onClick={onLearnMore}
            />
          </Flex>
        </div>
        <img src={Images.mobileMockups} />
      </Flex>
      <AuthLayout ref={refs.authLayout} />
    </Styled>
  );
};

const Styled = styled.div`
  height: 100vh;
  background: white url(${Images.authScreenBg}) center/cover no-repeat;
  ${(_) =>
    _.theme.mobile(
      `background: white url(${Images.authMobileScreenBg}) top/cover no-repeat;`
    )}
  header {
    color: ${(_) => _.theme.token.colorPrimary};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3.3rem 3.4rem 0 4.1rem;
    ${(_) => _.theme.mobile(`color: white; padding: 2rem 3rem 0;`)}
  }
  .content {
    margin-top: 5.3rem;
    padding: 0 16.1rem;
    ${(_) => _.theme.mobile(`padding: 0 3rem; margin-top: 16rem`)}
    img {
      width: 49.5rem;
      ${(_) => _.theme.mobile(`display:none;`)}
    }
  }
`;

export default View;
